import type { Language } from '@/bindings/Language'
import type { QuantityStep } from '@/bindings/QuantityStep'

export const STEPS: readonly QuantityStep[] = ['1', '0.5', '0.1']
export const STEP_LABELS = { '1': 'menu.step.whole', '0.5': 'menu.step.half', '0.1': 'menu.step.tenth' } as const

export function localeOf(language: Language) {
  return language === 'vi' ? 'vi-VN' : 'en-US'
}

/** `price` is an exact decimal string; `decimals` is the currency's scale, always shown in full. */
export function formatPrice(price: string, decimals: number, language: Language): string {
  const value = Number(price)
  if (!Number.isFinite(value)) return price
  return new Intl.NumberFormat(localeOf(language), {
    minimumFractionDigits: decimals,
    maximumFractionDigits: Math.max(decimals, 2),
  }).format(value)
}

/** An exact decimal quantity string ("1.9", "0.5", "3") in the viewer's digits; `grouping` off for an input's value. */
export function formatQuantity(quantity: string, language: Language, grouping = true): string {
  const value = Number(quantity)
  if (!Number.isFinite(value)) return quantity
  return new Intl.NumberFormat(localeOf(language), { maximumFractionDigits: 3, useGrouping: grouping }).format(value)
}
